import './Views.scss';

export { Home } from './home/Home';
export { QuemSomos } from './quem-somos/QuemSomos';
export { Associados } from './associados/Associados';
export { Sumario } from './sumario-gri/Sumario';
export { SobreRelatorio } from './sobre-relatorio/SobreRelatorio';
// export { PlanoAcao } from './plano-acao/PlanoAcao';
export { PlanoAcao2020 } from './plano-acao-2020/PlanoAcao2020';
export { MensagemPresidencia } from './mensagens/presidencia/MensagemPresidencia';
export { MensagemSuperintendencia } from './mensagens/superintendencia/MensagemSuperintendencia';
export { NotFound } from './errors/NotFound';
export { Governanca } from './governanca-corporativa/assembleia/Governanca';
export { Diretoria } from './governanca-corporativa/diretoria/Diretoria';
export { ConselhoFiscal } from './governanca-corporativa/conselho-fiscal/ConselhoFiscal';
export { ConselhoEtica } from './governanca-corporativa/conselho-de-etica/ConselhoEtica';
export { ComiteExecutivo } from './governanca-corporativa/comite-executivo/ComiteExecutivo';
export { OrganismosRepresentacao } from './governanca-corporativa/organismos-representacao/OrganismosRepresentacao';
export { Pessoas } from './pessoas-rh/Pessoas';
export { Relacionamentos } from './relacionamentos/Relacionamentos';
export { NossoAno } from './nosso-ano/NossoAno';
export { ParaOMercado } from './para-o-mercado/ParaOMercado';
export { DentroDeCasa } from './dentro-de-casa/DentroDeCasa';
export { Organograma } from './organograma/Organograma';

export { Iniciativas } from './iniciativas/Iniciativas';
// export { AgendaRecursos } from './iniciativas/agenda-recursos/AgendaRecursos';
export { Card1 } from './iniciativas/card1/Card1';
export { Card2 } from './iniciativas/card2/Card2';
export { Card3 } from './iniciativas/card3/Card3';
export { Card4 } from './iniciativas/card4/Card4';
export { Card5 } from './iniciativas/card5/Card5';
export { Card6 } from './iniciativas/card6/Card6';
export { Card7 } from './iniciativas/card7/Card7';
export { Card8 } from './iniciativas/card8/Card8';
export { Card9 } from './iniciativas/card9/Card9';
export { Card10 } from './iniciativas/card10/Card10';
export { Card11 } from './iniciativas/card11/Card11';
export { Card12 } from './iniciativas/card12/Card12';
export { Card13 } from './iniciativas/card13/Card13';
// export { Treinamentos } from './iniciativas/treinamentos/Treinamentos';
// export { DataFundos } from './iniciativas/data-fundos/DataFundos';
// export { PerfilInvestidor } from './iniciativas/perfil-investidor/PerfilInvestidor';
// export { CursosEducativos } from './iniciativas/cursos-educativos/CursosEducativos';
// export { MercadoDeCapitais } from './iniciativas/mercado-de-capitais/MercadoDeCapitais';
// export { AtuacaoInternacional } from './iniciativas/atuacao-internacional/AtuacaoInternacional';
// export { Selic40Anos } from './iniciativas/selic-40-anos/Selic40Anos';
// export { LeiLiberdadeEconomica } from './iniciativas/lei-liberdade-economica/LeiLiberdadeEconomica';
// export { SupervisaoAtivos } from './iniciativas/supervisao-ativos/SupervisaoAtivos';
// export { CulturaDeDados } from './iniciativas/cultura-de-dados/CulturaDeDados';
// export { CertificacaoEducacao } from './iniciativas/certificacao-educacao/CertificacaoEducacao';
// export { BalancoOrientacoesPenalidades } from './iniciativas/balanco-orientacoes-penalidades/BalancoOrientacoesPenalidades';

export { LinhaDoTempo } from './linha-do-tempo/LinhaDoTempo';
export { Eventos } from './eventos/Eventos';
export { ProgramaDeSupervisaoDigital } from './iniciativas/programa-de-supervisao-digital/ProgramaDeSupervisaoDigital';
export { ProgramaDeCompliance } from './iniciativas/programa-de-compliance/ProgramaDeCompliance';
export { GestaoDeFornecedores } from './iniciativas/gestao-de-fornecedores/GestaoDeFornecedores';
export { ComunicacaoInterna } from './iniciativas/comunicacao-interna/ComunicacaoInterna';
